import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,

    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { CreditCardFormRequest, CreditCardFormResponse, getCreditCardFormInfo } from "@tCentro/Services/CENCreditApplicationFormService";




type HandlerType = ApiHandler<
    CreditCardFormRequest & HasOnSuccess<CreditCardFormResponse>,
    CreditCardFormResponse &  HasOnError
>;


export const PopulateApiParameter: HandlerType = props => {
   // Destructure to remove handler callbacks
    const { onSuccess, onError, ...apiData } = props.parameter;
    props.apiParameter = apiData; // only API fields now
};


export const DispatchBeginCreditCardData: HandlerType = props => {
    (props as any).dispatch({
        type: "Custom/CreditCardData/BeginLoad",
    });
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if ( props.apiResult?.errorMessage) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await getCreditCardFormInfo(props.apiParameter);
    } catch (error) {
        if (isApiError(error)) {
            const errorMsg = error.errorJson?.message || error.errorMessage;

            if (errorMsg) {
               
                props.apiResult = { ...props.apiResult, errorMessage: errorMsg };
            
            }
        }

  
     
        
    }
};


export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.apiResult?.errorMessage) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};




export const DispatchCompleteCreditCard: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    (props as any).dispatch({
        type: "Custom/CreditCard/CompletedLoad",
        result: props.apiResult,
    });
};


export const chain = [
    DispatchBeginCreditCardData,
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompleteCreditCard,
];


const creditCardFormHandler = createHandlerChainRunner(chain, "creditCardFormHandler");

export default creditCardFormHandler;
